/**
 * Particle System for visual effects
 */

interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  size: number;
  color: string;
  alpha: number;
  gravity: number;
}

export class ParticleSystem {
  private particles: Particle[] = [];

  public createExplosion(x: number, y: number, color: string = '#ff8800', count: number = 20): void {
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count;
      const speed = 100 + Math.random() * 100;
      
      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: 1,
        maxLife: 1,
        size: 3 + Math.random() * 3,
        color,
        alpha: 1,
        gravity: 200
      });
    }
  }

  public createPowerUpEffect(x: number, y: number, color: string): void {
    for (let i = 0; i < 15; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 50 + Math.random() * 50;
      
      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 100,
        life: 1.5,
        maxLife: 1.5,
        size: 4 + Math.random() * 4,
        color,
        alpha: 1,
        gravity: 50
      });
    }
  }

  public createTrail(x: number, y: number, color: string): void {
    this.particles.push({
      x: x + (Math.random() - 0.5) * 5,
      y: y + (Math.random() - 0.5) * 5,
      vx: 0,
      vy: 0,
      life: 0.3,
      maxLife: 0.3,
      size: 3,
      color,
      alpha: 0.8,
      gravity: 0
    });
  }

  public createComboEffect(x: number, y: number): void {
    for (let i = 0; i < 10; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 30 + Math.random() * 30;
      
      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 50,
        life: 0.8,
        maxLife: 0.8,
        size: 2 + Math.random() * 2,
        color: '#ffff00',
        alpha: 1,
        gravity: 100
      });
    }
  }

  public update(deltaTime: number): void {
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const p = this.particles[i];
      
      p.life -= deltaTime;
      if (p.life <= 0) {
        this.particles.splice(i, 1);
        continue;
      }
      
      p.x += p.vx * deltaTime;
      p.y += p.vy * deltaTime;
      p.vy += p.gravity * deltaTime;
      
      p.alpha = p.life / p.maxLife;
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    
    for (const p of this.particles) {
      ctx.globalAlpha = p.alpha;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    }
    
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  public clear(): void {
    this.particles = [];
  }
}
